/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Ad_ExportInputs */



/**
* | output |
* | --- |
* | "Audio Description (Described Video) Export (.mp3, .wav, .flac)" |
*
* @param {Signup_Compare_Ad_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_ad_export = /** @type {((inputs?: Signup_Compare_Ad_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Ad_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Audio Description (Described Video) Export (.mp3, .wav, .flac)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio Description (Described Video) Export (.mp3, .wav, .flac)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Audio Description (Described Video) Export (.mp3, .wav, .flac)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Audio Description (Described Video) Export (.mp3, .wav, .flac)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Audio Description (Described Video) Export (.mp3, .wav, .flac)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Audio Description (Described Video) Export (.mp3, .wav, .flac)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Audio Description (Described Video) Export (.mp3, .wav, .flac)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Audio Description (Described Video) Export (.mp3, .wav, .flac)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Audio Description (Described Video) Export (.mp3, .wav, .flac)")
	return /** @type {LocalizedString} */ ("Audio Description (Described Video) Export (.mp3, .wav, .flac)")
});